declare namespace $ {

	type __shm_hitalama_map_head_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_head['slideshow_enabled'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_head['map'] >['slideshow_enabled'] >[0]
	>
	type __shm_hitalama_map_head_2 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_head['camera_locked'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_head['map'] >['camera_locked'] >[0]
	>
	type __shm_hitalama_map_head_3 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_head['backup_time'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_head['map'] >['backup_time'] >[0]
	>
	type __shm_hitalama_map_head_4 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_head['slideshow_frame'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_head['map'] >['slideshow_frame'] >[0]
	>
	type __shm_hitalama_map_head_5 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_head['viewport_frames_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_head['map'] >['viewport_frames_visible'] >[0]
	>
	type __shm_hitalama_map_head_6 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_head['title'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_head['map'] >['title'] >[0]
	>
	type $mol_link_iconed__sub_shm_hitalama_map_head_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link_iconed['sub'] >
	>
	type $mol_link_iconed__uri_shm_hitalama_map_head_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['open_in_new_uri'] >
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_link_iconed__click_shm_hitalama_map_head_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['open_in_new_click'] >
		,
		ReturnType< $mol_link_iconed['click'] >
	>
	type $mol_link_iconed__external_shm_hitalama_map_head_10 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link_iconed['external'] >
	>
	type $mol_string_button__value_shm_hitalama_map_head_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $shm_hitalama_map_settings__map_shm_hitalama_map_head_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['map'] >
		,
		ReturnType< $shm_hitalama_map_settings['map'] >
	>
	type $shm_hitalama_map_settings__map_cut_shm_hitalama_map_head_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['map_cut'] >
		,
		ReturnType< $shm_hitalama_map_settings['map_cut'] >
	>
	type $shm_hitalama_map_settings__zoom_shm_hitalama_map_head_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['zoom'] >
		,
		ReturnType< $shm_hitalama_map_settings['zoom'] >
	>
	type $shm_hitalama_map_settings__shift_shm_hitalama_map_head_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['shift'] >
		,
		ReturnType< $shm_hitalama_map_settings['shift'] >
	>
	type $mol_pick__hint_shm_hitalama_map_head_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_map_head_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_head_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_hitalama_map_head_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_head_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_icon__hint_shm_hitalama_map_head_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_head_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['Widget_list_visible_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_head_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_head['widget_list_visible'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_vector_2d__shm_hitalama_map_head_24 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	export class $shm_hitalama_map_head extends $mol_view {
		slideshow_enabled( next?: ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['slideshow_enabled'] > ): ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['slideshow_enabled'] >
		camera_locked( next?: ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['camera_locked'] > ): ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['camera_locked'] >
		backup_time( next?: ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['backup_time'] > ): ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['backup_time'] >
		slideshow_frame( next?: ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['slideshow_frame'] > ): ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['slideshow_frame'] >
		slideshow_frame_str( ): ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['slideshow_frame_str'] >
		viewport_frames_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['viewport_frames_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['viewport_frames_visible'] >
		title( next?: ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['title'] > ): ReturnType< ReturnType< $shm_hitalama_map_head['map'] >['title'] >
		Open_in_new_icon( ): $mol_icon_open_in_new
		open_in_new_uri( ): string
		open_in_new_click( next?: any ): any
		Open_in_new( ): $mol_link_iconed
		Title( ): $mol_string_button
		Settings_trigger_icon( ): $mol_icon_dots_vertical
		map_cut( next?: any ): any
		Settings_content( ): $shm_hitalama_map_settings
		Settings( ): $mol_pick
		Wrapper2( ): $mol_view
		Wrapper( ): $mol_view
		Widget_list_visible_icon( ): $mol_icon_format_list_bulleted
		widget_list_visible( next?: boolean ): boolean
		Widget_list_visible( ): $mol_check_icon
		map( ): $shm_hitalama_map
		zoom( next?: number ): number
		shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number>
		widget_headers_visible( next?: boolean ): boolean
		file_list_visible( next?: boolean ): boolean
		widget_props_visible( next?: boolean ): boolean
		editor_mode_enabled( next?: boolean ): boolean
		arrows_visible( next?: boolean ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map